import { XStack, Image, View } from '@my/ui'
import tzalogo from './tzalogo.svg'
import tzalogoSmall from './Logo-ShapeOnly-Transparent.svg'
import menuIcon from './menuButton.svg'
import type React from 'react'

export const MenuLogo: React.FC<any> = (props = {}) => <Image src={menuIcon} style={{ cursor: 'pointer', height: 30, width: 30 }} {...props} />

export const TZALogo: React.FC<{small?: boolean, [x: string]: any}> = ({small, ...restProps}) => (
  <XStack {...restProps}>
    <View>
      {/* <div style={{ minWidth: 32, marginLeft: 20, marginRight: 5 }}> */}
      {/* tzalogosvg */}
      {<Image
        src={small ? tzalogoSmall : tzalogo}
        style={{ width: 100, height: small ? 30 : 60}}
      />}
    </View>
  </XStack>
)
